import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Text from '../components/text'
import ColumnIndicator from '../components/column_indicator'
import List from '../components/list'
import Counter from '../components/counter'
import { parse, format } from 'url'

function resizeUrl(avatar) {
  if (!avatar) return avatar
  const parts = parse(avatar)
  let pathname = parts.pathname
  if (pathname.indexOf('cdn-cgi') === -1) {
    //parts.pathname = `/cdn-cgi/image/width=88,quality=100,fit=scale-down${pathname}`
  }
  return format(parts)
}

class Shortcuts extends ImmutablePureComponent {

  render() {
    const {
      isLoading,
      isError,
      shortcuts,
      size,
    } = this.props

    if (isError) {
      return <ColumnIndicator type='error' message='Error fetching shortcuts' />
    }

    const listItems = shortcuts.map((s) => {
      if (s.get('shortcut_type') === 'tag') {
        return {
          to: s.get('to'),
          title: (
            <div className={[_s.d, _s.flexRow].join(' ')}>
              <div
                className={[_s.d, _s.circle, _s.bgSecondary, _s.aiCenter, _s.jcCenter, _s.mr15].join(' ')}
                style={{ height: '16px', width: '16px' }}
              >
                <Text size='small' color='secondary'>#</Text>
              </div>
              <Text color='primary' weight='normal'>
                {s.get('title')}
              </Text>
            </div>
          )
        }
      }
      return {
        to: s.get('to'),
        title: s.get('title'),
        count: s.get('unread_count'),
        image: resizeUrl(s.get('image')),
        icon: s.get('icon'),
      }
    })

    return (
      <List
        size={size}
        scrollKey='shortcuts'
        emptyMessage='You have no shortcuts. Click the star on profiles or groups to create a shortcut'
        items={listItems}
        showLoading={isLoading}
      />
    )
  }

}

const mapStateToProps = (state, { type }) => {
  const allShortcuts = state.getIn(['shortcuts', 'items'])
  const shortcuts = !!type ? allShortcuts.filter((s) => s.get('shortcut_type') === type) : allShortcuts

  return {
    shortcuts,
    isError: state.getIn(['shortcuts', 'isError']),
    isLoading: state.getIn(['shortcuts', 'isLoading']),
  }
}

Shortcuts.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  shortcuts: ImmutablePropTypes.list,
  type: PropTypes.string,
  size: PropTypes.string,
}

export default connect(mapStateToProps)(Shortcuts)